// src/components/header/index.jsx
import React from 'react';
import { Layout, Menu, Avatar, Dropdown } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { UserOutlined, LogoutOutlined, HomeOutlined, BookOutlined, EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './index.css';

const { Header } = Layout;

const AppHeader = ({ loggedInUser, onLogout }) => {
  const location = useLocation();

  // 导航菜单项
  const menuItems = [
    {
      key: '/',
      label: <Link to="/">首页</Link>,
      icon: <HomeOutlined />,
    },
    {
      key: '/archive',
      label: <Link to="/archive">归档</Link>,
      icon: <BookOutlined />,
    },
    {
      key: '/about',
      label: <Link to="/about">关于</Link>,
      icon: <InfoCircleOutlined />,
    },
  ];

  // 如果用户已登录，添加写文章菜单项
  if (loggedInUser) {
    menuItems.splice(2, 0, {
      key: '/write',
      label: <Link to="/write">写文章</Link>,
      icon: <EditOutlined />,
    });
  }

  // 用户下拉菜单项
  const userMenuItems = loggedInUser
    ? [
        {
          key: 'profile',
          label: <Link to="/about">个人资料</Link>,
          icon: <UserOutlined />,
        },
        {
          key: 'logout',
          label: '退出登录',
          icon: <LogoutOutlined />,
          onClick: onLogout,
        },
      ]
    : [];

  // 渲染用户头像或登录按钮
  const userAction = loggedInUser ? (
    <Dropdown
      menu={{ items: userMenuItems }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Avatar 
        size="large" 
        src="/default-avatar.png"
        icon={<UserOutlined />}
        className="user-avatar"
        style={{ cursor: 'pointer', backgroundColor: '#1890ff' }}
      />
    </Dropdown>
  ) : (
    <Link to="/auth" className="login-button">
      <Avatar 
        size="large" 
        src="/default-avatar.png"
        icon={<UserOutlined />}
        className="user-avatar"
        style={{ backgroundColor: '#1890ff' }}
      />
    </Link>
  );

  return (
    <Header className="app-header">
      <div className="header-content">
        <div className="logo">
          <Link to="/">我的博客</Link>
        </div>
        <div className="nav-menu">
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className="main-menu"
          />
        </div>
        <div className="user-actions">
          {userAction}
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;